var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 195 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1603 -3706.837)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1629 3706.837)",
    fill: "none",
    stroke: "#411fd1",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 222,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 163,
    height: 216,
    rx: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1606 3804.837)",
    fill: "#050314",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 138,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 137,
    rx: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1603 3801.57)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.445,0H10.627A10.638,10.638,0,0,0,0,10.626V134.64a10.638,10.638,0,0,0,10.626,10.627H64.444a10.638,10.638,0,0,0,10.627-10.626V10.627A10.638,10.638,0,0,0,64.445,0ZM70.2,134.641a5.752,5.752,0,0,1-5.752,5.752H10.627a5.752,5.752,0,0,1-5.752-5.752V10.627a5.752,5.752,0,0,1,5.752-5.752h8.5a2.292,2.292,0,0,1,2.242,1.82l.475,2.257A3.461,3.461,0,0,0,25.233,11.7H50.326A3.461,3.461,0,0,0,53.713,8.95l.475-2.256a2.292,2.292,0,0,1,2.243-1.819h8.014A5.752,5.752,0,0,1,70.2,10.626Z",
    fill: "#411fd1"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTab);
export default __webpack_public_path__ + "static/media/tab.125c1ad7.svg";
export { ForwardRef as ReactComponent };